export const STYLE_CONFIG = {
  Classic: {
    descriptionByDevice: {
      'Calendar 2':
        'Made of hard shell, durable plastic. 15" Calendar Snap Frames are only compatible with Skylight Calendar 2',
      'Calendar Max': 'Made of hard shell, durable plastic',
    },
    colorsByDevice: {
      'Calendar 2': [
        { name: 'White', swatch: 'rgba(255, 255, 255, 1)' },
        { name: 'Black', swatch: 'rgba(46, 46, 46, 1)' },
        { name: 'Sage', swatch: 'linear-gradient(139deg, #b0baa4 20%, #a0ad94 50%, #8a9478 80%)' },
        { name: 'Lagoon', swatch: '#93acb7' },
      ],
      'Calendar Max': [
        { name: 'White', swatch: 'rgba(255, 255, 255, 1)' },
        { name: 'Black', swatch: 'rgba(46, 46, 46, 1)' },
      ],
    },
    prices: {
      'Calendar 2': 29.99,
      'Calendar Max': 39.99,
    },
  },
  'Shadow Box': {
    descriptionByDevice: {
      'Calendar 2':
        'Made of 100% aluminum with natural metal finish. 15" Calendar Snap Frames are only compatible with Skylight Calendar 2',
      'Calendar Max': 'Made of 100% aluminum with natural metal finish',
    },
    colorsByDevice: {
      'Calendar 2': [
        { name: 'Charcoal', swatch: 'linear-gradient(145deg, #595959 25.12%, #2e2e2e 77.36%)' },
        { name: 'Silver', swatch: 'linear-gradient(180deg, #f8f8f8 0%, #acafae 100%)' },
      ],
      'Calendar Max': [
        { name: 'Charcoal', swatch: 'linear-gradient(145deg, #595959 25.12%, #2e2e2e 77.36%)' },
        { name: 'Silver', swatch: 'linear-gradient(180deg, #f8f8f8 0%, #acafae 100%)' },
      ],
    },
    prices: {
      'Calendar 2': 49.99,
      'Calendar Max': 59.99,
    },
  },
  Wood: {
    descriptionByDevice: {
      'Calendar 2':
        'Made of 100% natural wood. 15" Calendar Snap Frames are only compatible with Skylight Calendar 2',
      'Calendar Max': 'Made of 100% natural wood',
    },
    colorsByDevice: {
      'Calendar 2': [
        { name: 'Walnut', swatch: 'linear-gradient(145deg, #b67b3b 25.12%, #895721 77.36%)' },
        { name: 'Birch', swatch: 'linear-gradient(139deg, #f5c97f 21.02%, #cfa55d 66.56%)' },
      ],
      'Calendar Max': [
        { name: 'Walnut', swatch: 'linear-gradient(145deg, #b67b3b 25.12%, #895721 77.36%)' },
        { name: 'Birch', swatch: 'linear-gradient(139deg, #f5c97f 21.02%, #cfa55d 66.56%)' },
      ],
    },
    prices: {
      'Calendar 2': 49.99,
      'Calendar Max': 59.99,
    },
  },
}

export const normalizeCalendarSnapFrameColor = (color = '') => {
  if (color === 'Natural Aluminum' || color === 'Aluminum') return 'Silver'
  return color
}
